import { useState } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { Row, Col, Container } from "react-bootstrap";
import { DateTime } from "luxon";
import { useSessionStore } from "../../Stores/SessionStore";
import Home from "./Pages/Home/Home";
import Logo from "../Core/Logo";
import React from "react";
import { observer } from "mobx-react-lite";
import Recharge from "./Pages/Recharge/Recharge";
import UserProfile from "./Pages/UserProfile/UserProfile";
import { useEffect } from "react";
import ChurnedServiceSalesAgentModal from "./ChurnedServiceSalesAgentModal";
import AlertModal from "../Core/AlertModal";
import GradientButton from "../Core/GradientButton";
import SetPinModal from "./SetPinModal";

const Portal = observer(function Portal() {
	const store = useSessionStore();
	const navigate = useNavigate();

	const [churnedServiceSalesAgentModal, setChurnedServiceSalesAgentModal] = useState({ show: false, salesAgents: [] });
	const [salesAgents, setSalesAgents] = useState([]);
	const [alertModal, setAlertModal] = useState(null);

	function handleLogoutClicked() {
		store.Logout();
		navigate("/");
	}

	useEffect(() => {
		if(store.UserIsLoggedIn) {
			store.LoadCustomerDetails();
		} else {
			navigate("/");
		}
		
	}, [store.UserIsLoggedIn])

	async function getSalesAgents() {

        let result = await store.SalesAgentsService.GetSalesAgents();

        if (result) {
            setSalesAgents(result.Data);
        } else {
            console.error("Failed to fetch sales agents.");
        }
    }

	async function handleSalesAgentSelect(salesAgent) {
		
		let result = await store.CustomersService.AddChurnedServiceAgent(store.CustomerDetails.Customer.Id, salesAgent);

		if (result && result.Success) {			
			setAlertModal({ show: true, message: "Your sales agent has been assigned successfully.", success: true, onClose: () => {
				store.LoadCustomerDetails();
				setAlertModal(null);
			} });
		} else {
			setAlertModal({ show: true, message: result.Message ?? "There was an error assigning your sales agent. Please try again later.", success: false, onClose: () => {
				setAlertModal(null);
			} });
		}
	}

	function handleLogoClicked() {
		var expiryDate = DateTime.fromISO(store.CustomerDetails.RadiusDetails.ExpiryDate);
		var trialExpiryDate = DateTime.fromISO(store.CustomerDetails.Customer.TrialExpiryDate);

		if (expiryDate.diffNow("days").days < -7 && store.CustomerDetails.RadiusDetails.ServiceId !== 4 && (store.CustomerDetails.Customer.TrialExpiryDate === null || (store.CustomerDetails.Customer.TrialExpiryDate !== null && trialExpiryDate.diffNow("days").days < -7))) {
			getSalesAgents();
			setChurnedServiceSalesAgentModal({
				show: true,
				salesAgents: salesAgents,
				onSelect: (salesAgent) => {
					
					setChurnedServiceSalesAgentModal({ show: false });
					handleSalesAgentSelect(salesAgent);
				},
				onClose: () => {
					setChurnedServiceSalesAgentModal({ show: false });
				}
			})
		}

	}

	return 	<Container fluid>
				<div className="p-2 p-md-4">
					<Row className="d-flex align-items-center my-4">
						<Col xs={12} md={8} lg={9}>
							<div onDoubleClick={ store?.CustomerDetails?.HasActiveChurnedAssignment === false ? handleLogoClicked : undefined }>
								<Logo />
							</div>
						</Col>
						<Col className="mt-4 mt-md-0">
							<GradientButton title="Home" variant="greenYellow" onClick={() => navigate("Home")} className="mb-3" />
							<GradientButton title="Logout" variant="yellowOrange" onClick={handleLogoutClicked} />
						</Col>
					</Row>
					{
						store.UserIsLoggedIn &&
						<React.Fragment>
							<Routes>
								<Route path="Home" element={ <Home></Home> }></Route>
									{
										store?.CustomerDetails?.Address !== null &&
										store?.CustomerDetails?.Address && store?.CustomerDetails?.Address?.InstallDate !== null &&
										store?.CustomerDetails?.Customer.IDDocumentId !== null &&
										<Route path="Recharge" element={ <Recharge></Recharge> }></Route>
									}
								<Route path="Profile" element={ <UserProfile></UserProfile> }></Route>
								<Route path="*" element={ <Navigate to="Home" /> }></Route>
							</Routes>
							<SetPinModal />
							{churnedServiceSalesAgentModal && <ChurnedServiceSalesAgentModal modal={churnedServiceSalesAgentModal} salesAgents={salesAgents} />}
							{alertModal && <AlertModal modal={alertModal} />}
						</React.Fragment>
					}
				</div>
			</Container>

});

export default Portal;